export enum PickupPoint {
  Omniva = "omniva",
  LPExpress = "lpx",
}
